import React from 'react';
import { Stack, Typography, Checkbox } from "@mui/material";
import ToggleInput from "../../../Switch";

const MilestoneActions = ({
  epicData,
  handleComplete,
  isEditable
}) => {
  return (
    <Stack
      direction="row"
      ml={2}
      alignItems="center"
      justifyContent="space-between"
      sx={{
        pointerEvents: isEditable ? "" : "none",
      }}
    >
      <Stack direction="row">
        <Typography mr={1} fontSize={12}>
          Is Locked
        </Typography>
        <ToggleInput
          name={epicData?.epic_name}
          defaultValue={epicData?.is_locked}
          epicData={epicData}
        />
      </Stack>
      <Stack direction="row" alignItems="center">
        <Typography mr={1} fontSize={12}>
          Completed
        </Typography>
        <Checkbox
          checked={epicData?.completed}
          onChange={() => handleComplete()}
        />
      </Stack>
    </Stack>
  );
};

export default MilestoneActions; 